import { PlpPageRouteEnum } from '@routes/enum/plpPageRoute.enum';
import { plpFilterProductType } from '@constants/plpFilterConstants';

const { BROADLOOM, CARPET_TILE, WALK_OFF_TILE, LUXURY_VINYL_TILE, ULTIMATE_FLEX_LVT, RESILIENT_SHEET, LAMINATED_WOOD } =
  plpFilterProductType;

export interface IPlpCategoryRoute {
  plpPageRoute: PlpPageRouteEnum;
  // Public (SEO) path segment used for the product type landing pages
  seoPath: string;
  // Path of the category page in the CMS, product type landing pages render this CMS page
  cmsPath: string;
  // Other path segments that resolve to the same category
  aliases: string[];
}

export interface IPlpProductTypeRoute {
  plpPageRoute: PlpPageRouteEnum;
  slug: string;
  productType: string;
}

export const plpCategoryRoutes: IPlpCategoryRoute[] = [
  {
    plpPageRoute: PlpPageRouteEnum.CARPET,
    seoPath: 'carpet',
    cmsPath: 'carpet',
    aliases: []
  },
  {
    plpPageRoute: PlpPageRouteEnum.HARD_SURFACE,
    seoPath: 'hard-surface',
    cmsPath: 'hardsurface',
    aliases: ['hardsurface']
  }
];

// Indexable product type landing pages, e.g. /carpet/carpet-tile, /hard-surface/luxury-vinyl-tile
export const plpProductTypeRoutes: IPlpProductTypeRoute[] = [
  { plpPageRoute: PlpPageRouteEnum.CARPET, slug: 'carpet-tile', productType: CARPET_TILE },
  { plpPageRoute: PlpPageRouteEnum.CARPET, slug: 'broadloom', productType: BROADLOOM },
  { plpPageRoute: PlpPageRouteEnum.CARPET, slug: 'walk-off', productType: WALK_OFF_TILE },
  { plpPageRoute: PlpPageRouteEnum.HARD_SURFACE, slug: 'luxury-vinyl-tile', productType: LUXURY_VINYL_TILE },
  { plpPageRoute: PlpPageRouteEnum.HARD_SURFACE, slug: 'resilient-sheet', productType: RESILIENT_SHEET },
  { plpPageRoute: PlpPageRouteEnum.HARD_SURFACE, slug: 'laminated-wood', productType: LAMINATED_WOOD },
  { plpPageRoute: PlpPageRouteEnum.HARD_SURFACE, slug: 'ultimate-flex-lvt', productType: ULTIMATE_FLEX_LVT }
];
